import { RESET_DB } from 'actions/orm'
import { GET_SAMPLE_CUSTOMERS_SUCCESS } from 'actions/sampleCustomers'
import { attr, Model } from 'redux-orm'

export type Fields = {
  id: string
  customer_name: string
  customer_email: string
  lifetime_spend: number | string
  days_since_last_visit: number | null
  loyalty_tier: string | null
}

export default class Customer extends Model {
  static modelName: string = 'Customer'

  static get fields(): any {
    return {
      id: attr(),
      customer_name: attr(),
      customer_email: attr(),
      lifetime_spend: attr(),
      days_since_last_visit: attr(),
      loyalty_tier: attr(),
    }
  }

  static reducer(action: any, Customer: any): void {
    switch (action.type) {
      case GET_SAMPLE_CUSTOMERS_SUCCESS: {
        const customers = action.payload.data.sample_customers || []
        customers.forEach((customerData: Fields) => {
          Customer.upsert(customerData)
        })
        break
      }
      case RESET_DB:
        Customer.all().delete()
        break
    }
  }
}
